<!--
  Footer for the queue layout. Renders the current location name supplied by
  the app via QueueLocationAbstraction — quietly hidden when none is set.
-->
<footer class="app-footer">
  @if (location(); as loc) {
    <span>{{ loc.name }}</span>
  }
</footer>
